<template>
  <component :is="sectionComponent" v-if="sectionComponent" v-bind="sectionProps" />
</template>

<script>
import TextSection from "./sections/TextSection.vue";
import ComparisonCards from "./sections/ComparisonCards.vue";
import ImageSection from "./sections/ImageSection.vue";
import CalloutSection from "./sections/CalloutSection.vue";
import CoverageList from "./sections/CoverageList.vue";
import ScenarioCards from "./sections/ScenarioCards.vue";
import OfferHighlight from "./sections/OfferHighlight.vue";
import InfoTable from "./sections/InfoTable.vue";
import PriceTable from "./sections/PriceTable.vue";
import SellerRetributionsPriceTable from "./sections/SellerRetributionsPriceTable.vue";

const SECTION_COMPONENTS = {
  text: "TextSection",
  comparison_cards: "ComparisonCards",
  image: "ImageSection",
  callout: "CalloutSection",
  coverage_list: "CoverageList",
  scenario_cards: "ScenarioCards",
  offer_highlight: "OfferHighlight",
  info_table: "InfoTable",
  price_table: "PriceTable",
  seller_retributions_price_table: "SellerRetributionsPriceTable",
};

const STYLE_PROP_MAP = {
  callout: "calloutStyle",
  coverage_list: "coverageStyle",
};

export default {
  name: "SectionRenderer",
  components: {
    TextSection,
    ComparisonCards,
    ImageSection,
    CalloutSection,
    CoverageList,
    ScenarioCards,
    OfferHighlight,
    InfoTable,
    PriceTable,
    SellerRetributionsPriceTable,
  },
  props: {
    section: { type: Object, required: true },
  },
  computed: {
    sectionComponent() {
      return SECTION_COMPONENTS[this.section.type] || null;
    },
    sectionProps() {
      const { type, style, ...rest } = this.section;
      const styleProp = STYLE_PROP_MAP[type];
      if (styleProp && style) {
        return { ...rest, [styleProp]: style };
      }
      return rest;
    },
  },
};
</script>
